import { apiClient } from "api/ApiClient";

/**
 * 予約可能溶媒一覧取得
 */
const getBookableSolvent = async (
    startDate: string,
    startTime: string,
    endTime: string,
    bookingTypeId: number,
    id?: number
) => {
    try {
        const response = await apiClient.get(`/booking_detail/bookable_solvents`, {
            id: id,
            startDate: startDate,
            startTime: startTime,
            endTime: endTime,
            bookingTypeId: bookingTypeId,
        });
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
    }
};

export const BookableSolventApi = {
    getBookableSolvent,
};
